export const columns = [
  {
    title: 'page_tenant_operation',
    key: 'action',
    width: 90,
    scopedSlots: { customRender: 'action' }
  },
  {
    title: "所属年份",
    dataIndex: "year",
    key: "year",
    ellipsis: true,
  },
  {
    title: "日期",
    dataIndex: "time",
    key: "time",
    ellipsis: true,
    scopedSlots: { customRender: 'time' }
  },
  {
    title: "休息日说明",
    dataIndex: "remark",
    key: "remark",
    ellipsis: true,
  },
]
